import { render, staticRenderFns } from "./AirwayBillUpload.vue?vue&type=template&id=9efc737a&scoped=true&"
import script from "./AirwayBillUpload.vue?vue&type=script&lang=ts&"
export * from "./AirwayBillUpload.vue?vue&type=script&lang=ts&"
import style0 from "./AirwayBillUpload.vue?vue&type=style&index=0&id=9efc737a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efc737a",
  null
  
)

export default component.exports